import classNames from 'classnames'
import * as React from 'react'

import styles from './AgentPoolTabToolbar.css'

type Props = {
  className?: string | undefined
  children: React.ReactNode
}

function AgentPoolTabToolbar({className, children}: Props): React.ReactElement {
  return <div className={classNames(className, styles.tabToolbar)}>{children}</div>
}

export default React.memo(AgentPoolTabToolbar)
